// extracted by mini-css-extract-plugin
export default {"accordion_wrapper":"Accordion_accordion_wrapper__0KJ54","assign_sensor_modal":"Accordion_assign_sensor_modal__zfO8d"};